import { VaccineAdministrationStatus } from "../Constants/VaccineAdministrationStatus";
import { AntigenStatus } from "./AntigenStatus";
import { CodeValue } from "./CodeValue";
import { LocationModel } from "./LocationModel";
import { NoteModel } from "./NoteModel";
import { PractitionerModel } from "./PractitionerModel";
import { RecordMetadata } from "./RecordMetadata";

class ImmunizationModel {
    public Metadata: RecordMetadata | null;
    public Id: number;
    public PatientId: number;
    public AdministeredBy: PractitionerModel;
    public Location: LocationModel;
    public IsSelfReported: boolean;
    public IsActive: boolean;
    public Date: string;
    public Status: VaccineAdministrationStatus;
    public OverrideStatus: CodeValue;
    public Vaccine: CodeValue;
    public VaccineAntigens: AntigenStatus[];
    public VaccineSite: CodeValue;
    public VaccineRoute: CodeValue;
    public VaccineTradeName: string;
    public LotNumber?: string | null;
    public LotId?: number;
    public DoseSize?: number;
    public DoseUnit?: CodeValue;
    public ExpirationDate: string | null;
    public ReasonsAdministered: CodeValue[];
    public ReasonsNotAdministered: CodeValue[];
    public OverrideReason: CodeValue | null;
    public Notes: NoteModel[];

    constructor(init?: Partial<ImmunizationModel>) {
        Object.assign(this, init);
    }
}

export { ImmunizationModel };
